/* Changes for PM-189 */
import AllActionTypes from '../Utility/AllActionTypes';
import { REHYDRATE } from 'redux-persist';

const initialState = {
    selectedBranch: {},
    branches: [],
    connectCentralInv: false
};

/* Ensure branch.label is always a string — guards against stale serialized JSX in localStorage */
const sanitizeBranch = (branch) => {
    if (!branch || typeof branch !== 'object') return {};
    return {
        ...branch,
        label: typeof branch.label === 'string'
            ? branch.label
            : String(branch.id || branch.value || '')
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        /* PM-189: Clear branches and selectedBranch on rehydrate to force fresh fetch with proper names */
        case REHYDRATE:
            if (action.key === 'root' && action.payload?.InventoryReducer) {
                return {
                    ...state,
                    selectedBranch: {},
                    connectCentralInv: false,
                    branches: [] // Clear all to force fresh fetch and auto-select on mount
                };
            }
            return state;
        case AllActionTypes.SET_INVENTORY_BRANCH:
            return {
                ...state,
                selectedBranch: sanitizeBranch(action.payload || {}),
                connectCentralInv: action.payload?.connect_central_inv || false
            };
        case AllActionTypes.SET_INVENTORY_BRANCHES:
            return {
                ...state,
                branches: (action.payload || []).map(sanitizeBranch)
            };
        default:
            return state;
    }
};
